import {IEntityMetaData, IEntityMetaDataCreateLoadOptions, IEntityMetaDataManager} from "./PA.MD.IF.Entity";
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as _ from "lodash"
import {esWB_DataObject, esWB_Entity, esWB_MasterData_Set, esWB_UI_AppExecutable} from "../PA.Core/PAdbSchema";
import {
    WB_AttributeTypeRow,
    WB_DataObjectRow,
    WB_EntityRow,
    WB_MasterDataSetRow,
    WB_UIAppExecutableRow
} from "../PA.Core/PAdbSchemaRows";
import {EntityMetaData} from "./EntityMetaData";

export class EntityMetaDataManager
    implements
        IEntityMetaDataManager
{
    dbContext: PAdbContext

    constructor() {}

    private getDbContext(options: { dbContext?: PAdbContext }): PAdbContext {
        if(!_.isEmpty(this.dbContext))
            return this.dbContext

        let dbContext = options.dbContext
        if(_.isEmpty(dbContext))
            dbContext = new PAdbContext()
        this.dbContext = dbContext
        return this.dbContext
    }


    async findByWbId(wbEntityId: number, options: IEntityMetaDataCreateLoadOptions): Promise<IEntityMetaData> {
        let dbContext = this.getDbContext(options)

        let entityRows = <WB_EntityRow[]> await dbContext.findUsingCache(esWB_Entity, [wbEntityId || -1])
        if(_.isEmpty(entityRows))
            return undefined
        let entityRow = _.first(entityRows)
        this.syncOptions(entityRow, options)
        return await this.createFromExistingRow(entityRow, options)
    }

    async findByMetaType(metaTypeId: string, metaWbId: number, options: IEntityMetaDataCreateLoadOptions): Promise<IEntityMetaData> {
        let dbContext = this.getDbContext(options)

        let entityRows = <WB_EntityRow[]> await dbContext.findAll(esWB_Entity, {
            where: {
                META_TYPE: metaTypeId,
                META_WB_ID: metaWbId,
                DELETED_IND: {neq: '1'}
            }
        })

        if(_.isEmpty(entityRows))
            return undefined

        let entityRow = _.first(entityRows)
        this.syncOptions(entityRow, options)
        return await this.createFromExistingRow(entityRow, options)
    }


    private async createFromExistingRow(pEntityRow: WB_EntityRow, options: IEntityMetaDataCreateLoadOptions): Promise<IEntityMetaData> {
        let dbContext = this.getDbContext(options)

        // Use the record Resolver yo
        if(_.isEmpty(pEntityRow))
            return undefined

        let aEMD = new EntityMetaData(pEntityRow)
        await aEMD.OnLoadComplete()

        return aEMD
    }

    async findOrCreate(options: IEntityMetaDataCreateLoadOptions): Promise<IEntityMetaData> {
        let dbContext = this.getDbContext(options)

        let rv: IEntityMetaData = undefined

        // Try to find by id, metas.., else create..
        let wbEntityId = +options.entityWbId
        if(_.isNumber(wbEntityId)){
            rv = await this.findByWbId(wbEntityId, {dbContext: options.dbContext})
            if(!_.isEmpty(rv))
                return rv
        }

        let metaWbId = +options.metaWbId
        let metaType = options.metaType

        if(_.isNumber(metaWbId) && !_.isEmpty(metaType)){
            rv = await this.findByMetaType(metaType, metaWbId, options)
            if(!_.isEmpty(rv))
                return rv
        }
        // Create a Record
        let newEntity = <WB_EntityRow> await dbContext.createRecordWithKey(esWB_Entity, {})
        await this.syncOptions(newEntity, options)
        let newEMD = new EntityMetaData(newEntity)
        await newEMD.OnLoadComplete()

        return newEMD
    }

    private async syncOptions(entityRow: WB_EntityRow, opts: IEntityMetaDataCreateLoadOptions): Promise<void> {
        let dbContext = this.getDbContext(opts)

        if(_.isEmpty(entityRow))
            return

        let er = entityRow.cif
        er.ENTITY_ID = opts.entityId || er.ENTITY_ID
        er.ENTITY_NAME = opts.entityName || er.ENTITY_NAME
        er.ENTITY_DIMENSION = opts.dimensionId || er.ENTITY_DIMENSION
        er.WB_MDSET_ID = opts.wbMasterDataSetId || er.WB_MDSET_ID
        er.META_WB_ID = opts.metaWbId ||er.META_WB_ID
        er.META_TYPE = opts.metaType || er.META_TYPE
        er.SET_TYPE = opts.setType || er.SET_TYPE

        // Check the FK for
        // 1. Master Data Set
        // 2. Data Object
        // 3. App Exec

        //--- 1. Master Data Set
        if(_.isEmpty(entityRow.WB_MasterDataSetRow)){
            let mdr = <WB_MasterDataSetRow> await dbContext.find(esWB_MasterData_Set, er.WB_MDSET_ID)
            if(mdr) {
                entityRow.WB_MasterDataSetRow = mdr
            }
        }

        //--- 2. Data Object
        if(_.isEmpty(entityRow.WB_DataObjectRow)){
            if(!_.isEmpty(opts?.dataObjectTypeId) && !_.isEmpty(opts?.dataObjectId)) {
                let arrDO = <WB_DataObjectRow[]>await dbContext.findAll(esWB_DataObject, {
                    where: {
                        DATAOBJECT_ID: opts.dataObjectId,
                        DATAOBJECT_TYPE: opts.dataObjectTypeId,
                        DELETED_IND: {neq: '1'}
                    }
                })
                if(arrDO.length){
                    let f = _.first(arrDO)
                    entityRow.cif.WB_DATAOBJECT_ID = f.cif.WB_DATAOBJECT_ID
                    entityRow.WB_DataObjectRow = f
                }
            } else {
                let f = <WB_DataObjectRow> await dbContext.find(esWB_DataObject, er.WB_DATAOBJECT_ID)
                if(!_.isEmpty(f))
                    entityRow.WB_DataObjectRow = f
            }
        }

        //--- 3. App Exec
        if(_.isEmpty(entityRow.WB_UIAppExecutableRow)){

            let pAppExecIds = opts?.appExecId || []
            if(!_.isEmpty(pAppExecIds)) {
                if(!_.isArray(pAppExecIds))
                    pAppExecIds = [pAppExecIds]
                for(let anAppExecId of pAppExecIds) {
                    let arrAppExec = <WB_UIAppExecutableRow[]>await dbContext.findAll(esWB_UI_AppExecutable, {
                        where: {
                            APPEXEC_ID: anAppExecId,
                            DELETED_IND: {neq: '1'}
                        }
                    })
                    if (arrAppExec.length) {
                        let f = _.first(arrAppExec)
                        entityRow.cif.WB_UI_APPEXEC_ID = f.cif.WB_UI_APPEXEC_ID
                        entityRow.WB_UIAppExecutableRow = f
                        break
                    }
                }
            } else {
                let f = <WB_UIAppExecutableRow> await dbContext.find(esWB_UI_AppExecutable, er.WB_UI_APPEXEC_ID)
                if(!_.isEmpty(f))
                    entityRow.WB_UIAppExecutableRow = f
            }

        }

    }


}